// extracted by mini-css-extract-plugin
export var growableInput = "_6i-0";
export var tagContainer = "_6i-2";
export var textInput = "_6i-1";